<div class="wrapper bg-area" *ngIf="!isMobile">
  <section id="etapa-email">
    <div class="container area-faca-parte">      
      <div class="sample-form" method="post" target="_top">
        <div class="body-faca-parte columns">
          <form class="column is-6" [formGroup]="form" style="margin: 0px auto;">           
            <div class="dados-pessoais">

              <h4>Muito Obrigado pela confirmação, {{data.nome}}!</h4>

              <p>Como esse é o seu Primeiro Acesso, vou precisar que você Renove Sua Senha para sua própria segurança.</p>

              <div class="field forms-dados" tabindex="1">
                <label class="email" name="email">Senha</label>
                <input name="email" type="password" maxlength="4" formControlName="novaSenha" placeholder="Senha" required>
                <span class="campo-erro" *ngIf="form.invalid">{{getErrorMessage('novaSenha')}}</span>
              </div>
              <div class="field forms-dados" tabindex="1">
                <label class="email" name="email">Confirme a senha</label>
                <input name="email" type="password" maxlength="4" formControlName="confirmaSenha" placeholder="Confirme a senha" required>
                <span class="campo-erro" *ngIf="form.invalid">{{getErrorMessage('confirmaSenha')}}</span>
              </div>
            </div>
            <button type="button" (click)="submit()" class="btn-verde">RENOVAR SENHA</button>
          </form>
        </div>
      </div>
    </div>
  </section>

  
</div>
<div class="wrapper bg-area" *ngIf="isMobile">
  <section id="etapa-email-mobile">
    <div class="container area-faca-parte">
      <div class="header-faca-parte columns">
        <div class="column is-6">
          <div class="title">
            <h3>Muito Obrigado pela confirmação, {{data.nome}}!</h3>
          </div>
          <p>Como esse é o seu Primeiro Acesso, vou precisar que você Renove Sua Senha para sua própria segurança.</p>
          <form [formGroup]="form" class="dados-pessoais">
            <div class="field forms-dados" tabindex="1">
              <label class="email" name="email"></label>
              <input name="email"
                     type="password"
                     maxlength="4"
                     formControlName="novaSenha"
                     placeholder="Senha"
                     required>
              <span class="campo-erro" *ngIf="form.invalid">{{getErrorMessage('novaSenha')}}</span>
            </div>
            <div class="field forms-dados" tabindex="1">
              <label class="email" name="email"></label>
              <input name="email"
                     type="password"
                     maxlength="4"
                     formControlName="confirmaSenha"
                     placeholder="Confirme a senha"
                     required>
              <span class="campo-erro" *ngIf="form.invalid">{{getErrorMessage('confirmaSenha')}}</span>
            </div>
            <div class="btn-mobile">
              <button type="button" (click)="submit()" class="btn-verde">RENOVAR SENHA</button>
            </div>
          </form>
        </div>

      </div>
    </div>
  </section>
</div>
